<div class="admin-content">
  <cei-admin-page-cabecalho titulo="Nova pessoa / usuário" [rotaVoltar]="'/admin/pessoas'" />
  <admin-pessoa-usuario-form
    [form]="form"
    mode="create"
    (submitForm)="onSubmit($event)"
    (fotoSelected)="onFotoSelected($event)"
    (fotoRemoved)="onFotoRemoved()"
  />
</div>
